import React from 'react';
import { SettingsIcon, ArrowRightIcon } from 'lucide-react';
import { mechanismPillars } from '../data/pains';
export function MechanismSection() {
  return <section className="w-full bg-white py-16 sm:py-20" aria-labelledby="mecanismo-title" data-id="element-169" data-mp="hesyqttiic86">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-170" data-mp="cfpuvcp9qc1s">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16" data-id="element-171" data-mp="8ctgjy6rh23n">
          <div data-id="element-172" data-mp="152kfc9m35bf9">
            <h2 id="mecanismo-title" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-173" data-mp="150zjmgo1bmft">
              ¿Por qué todo lo que probaste antes no funcionó?
            </h2>
            <div className="mt-6 space-y-5 text-lg leading-relaxed text-body" data-id="element-174" data-mp="rb5s1ql5ao2e">
              <p data-id="element-175" data-mp="r933zc3jz50b">
                Las dietas genéricas fallan por una razón simple:{' '}
                <span className="font-semibold text-petrol" data-id="element-176" data-mp="1nuwq9kqt1l10">no están hechas para vos.</span> Están
                hechas para un paciente promedio, en un país que no es el tuyo, con una cocina que no es
                la tuya.
              </p>
              <p data-id="element-177" data-mp="cpbp7tv3qg2b">
                Te piden que reemplaces el asado con pollo al vapor. Que cambies el mate por agua tibia
                con limón. Que comas sin sal, sin sabor, sin identidad.
              </p>
              <p data-id="element-178" data-mp="2y7dd30q3bbp">
                Y el resultado es predecible: seguís tres días, una semana si tenés mucha fuerza de
                voluntad — y después el sistema colapsa, porque ningún ser humano puede sostenerse en una
                dieta que no lo representa.
              </p>
              <p className="font-display text-xl font-bold leading-snug text-petrol" data-id="element-179" data-mp="3b7hbdjvqom1q">
                La solución no es comer menos argentino. La solución es comer argentino — pero bien.
              </p>
            </div>
          </div>

          <div className="rounded-3xl border border-sage/30 bg-sage-soft p-6 sm:p-10" data-id="element-180" data-mp="19g46uvxoog67">
            <p className="text-sm font-bold uppercase tracking-[0.14em] text-sage-deep" data-id="element-181" data-mp="1edvxznqi7y9c">
              Por eso desarrollamos el
            </p>
            <h3 className="mt-3 flex items-start gap-3 font-display text-2xl font-extrabold leading-tight text-petrol sm:text-3xl" data-id="element-182" data-mp="17y5kadr5bq4c">
              <SettingsIcon className="mt-1 h-7 w-7 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-183" data-mp="130417stpzqsv" />
              Método de Sustitución Criolla Inteligente
            </h3>
            <p className="mt-4 text-base leading-relaxed text-body" data-id="element-184" data-mp="1vngoy6bma4nr">
              La única metodología diseñada específicamente para adaptar la cocina argentina tradicional
              a una dieta apta para diabéticos: sin eliminar platos, sin ingredientes imposibles y sin
              renunciar al sabor que te define.
            </p>
            <p className="mt-4 font-semibold text-petrol" data-id="element-185" data-mp="1hvjys7tie4u0">
              No es magia. Es ciencia aplicada a tu cocina:
            </p>
            <ul className="mt-5 space-y-4" data-id="element-186" data-mp="2egc45vd2d452">
              {mechanismPillars.map(pillar => <li key={pillar} className="flex gap-3 text-base leading-relaxed text-body" data-id="element-187" data-mp="29leq2a0xg4lb">
                  <ArrowRightIcon className="mt-1 h-4 w-4 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-188" data-mp="3scc6ggub47y6" />
                  <span data-id="element-189" data-mp="162em5b3low2">{pillar}</span>
                </li>)}
            </ul>
            <p className="mt-8 border-t border-sage/30 pt-6 font-display text-xl font-extrabold text-petrol" data-id="element-190" data-mp="548in5kjxqda">
              El resultado: el mismo sabor. Sin el pico de glucosa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}